import { isArray } from "..";
import { isObject, isUndefined } from "./typeChecker";

export const filterUndefinedFields = (o: any) => {
  // undefined or null
  if (!o) return o;

  // if array
  if (isArray(o)) {
    // first remove all undefined items from the array
    // recursively remove the undefined fields from the items in the array
    return o.filter((item) => !isUndefined(item)).map((item) => filterUndefinedFields(item));
  }

  // if object
  if (isObject(o)) {
    return Object.fromEntries(
      Object.entries(o)
        .filter(([_, value]) => !isUndefined(value))
        .map(([key, value]) => [key, filterUndefinedFields(value)])
    );
  }

  // everything else
  return o;
};
